import { ICommonRequest } from "../../../model/request/ICommonRequest";
import { IDonHangChiTiet } from "../../../model/respone/don-hang/IDonHangChiTiet";
import { IDonHangChiTietViewModel } from "../../../model/respone/don-hang/IDonHangChiTietViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDonHangChiTietActionTypeDefine = {
    LOAD_START: {} as ICommonRequest,
    LOAD_SUCCESS: {} as IDonHangChiTietViewModel[],
    LOAD_ERROR: "",

    LOAD_DON_HANG_START: 0,
    LOAD_DON_HANG_SUCCESS: {} as IDonHangChiTietViewModel[],
    LOAD_DON_HANG_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | IDonHangChiTiet,
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IDonHangChiTiet,
    SAVE_SUCCESS: {} as IDonHangChiTiet,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",

    CHANGED_TRANGTHAI_SELECTED_IDS: [] as number[],
}

export const eDonHangChiTietActionTypeIds = generateActionTypeIds(eDonHangChiTietActionTypeDefine, "DON_HANG_CHI_TIET");

export type IDonHangChiTietActions = IGenericActionType<typeof eDonHangChiTietActionTypeDefine, "DON_HANG_CHI_TIET">;
